import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';

const floatingMotion = (delay: number, reducedMotion: boolean | null) =>
  reducedMotion
    ? {}
    : {
        y: [0, -18, 0],
        rotate: [-3, 3, -3],
        transition: { delay, duration: 4 + delay, repeat: Infinity, ease: 'easeInOut' as const },
      };

export const DinosaurBackground: React.FC = () => {
  const reducedMotion = useReducedMotion();

  return (
    <div className="fixed inset-0 overflow-hidden bg-gradient-to-b from-sky-300 via-emerald-200 to-emerald-700">
      <div className="absolute left-[8%] top-[9%] h-24 w-24 rounded-full bg-amber-200 shadow-[0_0_70px_rgba(253,224,71,0.8)]" />
      <div className="absolute inset-x-0 bottom-0 h-[38%] bg-gradient-to-t from-emerald-950 to-emerald-700 [clip-path:polygon(0_40%,10%_10%,20%_42%,32%_4%,44%_40%,58%_12%,72%_45%,84%_8%,100%_38%,100%_100%,0_100%)]" />
      {['🦕', '🦖', '🥚', '🌿', '🦴'].map((emoji, index) => (
        <motion.div
          key={emoji}
          animate={floatingMotion(index * 0.35, reducedMotion)}
          className="absolute select-none text-5xl opacity-80 drop-shadow-lg sm:text-7xl"
          style={{
            left: `${10 + index * 20}%`,
            top: `${34 + (index % 2) * 22}%`,
          }}
          aria-hidden="true"
        >
          {emoji}
        </motion.div>
      ))}
    </div>
  );
};

export const CandyBackground: React.FC = () => {
  const reducedMotion = useReducedMotion();

  return (
    <div className="fixed inset-0 overflow-hidden bg-gradient-to-b from-sky-200 via-pink-100 to-violet-300">
      <div className="absolute inset-x-0 bottom-0 h-[36%] bg-gradient-to-t from-pink-400 to-pink-200 [clip-path:polygon(0_38%,12%_12%,24%_36%,38%_4%,52%_40%,66%_10%,80%_34%,92%_8%,100%_28%,100%_100%,0_100%)]" />
      {['🍭', '🍬', '🧁', '🍩', '🌈', '🍪'].map((emoji, index) => (
        <motion.div
          key={`${emoji}-${index}`}
          animate={floatingMotion(index * 0.25, reducedMotion)}
          className="absolute select-none text-4xl opacity-75 drop-shadow-md sm:text-6xl"
          style={{
            left: `${6 + index * 17}%`,
            top: `${18 + (index % 3) * 20}%`,
          }}
          aria-hidden="true"
        >
          {emoji}
        </motion.div>
      ))}
    </div>
  );
};
